export const isMaintenanceMode = () =>
  process.env.REACT_APP_MAINTENANCE_MODE === "true";
